import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initAttributes(root = document) {
    const section = root.querySelector('.attributes');
    if (!section) return;

    const swiperNode = section.querySelector('[data-js="attributes-swiper"]');
    if (!swiperNode) return;

    const navItems = Array.from(section.querySelectorAll('[data-js="attributes-nav-item"]'));
    const prevBtn = section.querySelector('[data-js="attributes-prev"]');
    const nextBtn = section.querySelector('[data-js="attributes-next"]');
    const VISIBLE_SLIDES = 3;
    const SPACE_BETWEEN = 20;

    function setFixedHeight() {
        const firstCard = swiperNode.querySelector('.attributes__card');
        if (!firstCard) return;
        const cardHeight = firstCard.getBoundingClientRect().height;
        if (cardHeight === 0) return;

        const totalSlides = swiperNode.querySelectorAll('.attributes__slide').length;
        const slidesToShow = Math.min(VISIBLE_SLIDES, totalSlides);

        swiperNode.style.height = `${cardHeight * slidesToShow + SPACE_BETWEEN * (slidesToShow - 1)}px`;
    }

    setFixedHeight();

    const totalSlides = swiperNode.querySelectorAll('.attributes__slide').length;
    const loopEnabled = totalSlides > VISIBLE_SLIDES;

    const swiper = new Swiper(swiperNode, {
        modules: [Navigation],
        direction: 'vertical',
        slidesPerView: Math.min(VISIBLE_SLIDES, totalSlides),
        spaceBetween: SPACE_BETWEEN,
        loop: loopEnabled,
        watchOverflow: true,
        navigation: {
            prevEl: prevBtn,
            nextEl: nextBtn,
        },
        on: {
            slideChange(sw) {
                setActive(sw.realIndex);
            },
        },
    });

    function setActive(index) {
        navItems.forEach((btn, i) => btn.classList.toggle('is-active', i === index));
    }

    setActive(swiper.realIndex);

    navItems.forEach((btn, i) => {
        btn.addEventListener('click', () => {
            loopEnabled ? swiper.slideToLoop(i) : swiper.slideTo(i);
        });
    });

    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            setFixedHeight();
            swiper.update();
        }, 150);
    });
}
